import MessageModal from '../../../message-modal';
import BasketShortSummary from '../../../utils/basket-short-summary';
import DetectMobileBrowsers from '../../../utils/detect-mobile-browsers';
import Validation from '../../../utils/validation';

class Towary {
    constructor() {
        this.towarSettings = {
            towary_total: 0,
            towary: [],
            currentPage: 1,
            liczbaStron: 1,
            ilosc_na_stronie: 10,
            id_kategorii: null
        };
        this.productList = $('#products-list');
        this.validation = new Validation([
            {
                inputClass: 'lista-towarow-ilosc',
                regExp: new RegExp('^[1-9]{1,2}[0]?$'),
                value: 1
            },
            {
                inputClass: 'js-cena-od',
                regExp: new RegExp('^[0-9]{1,}$'),
                value: ''
            },
            {
                inputClass: 'js-cena-do',
                regExp: new RegExp('^[1-9]{1,}[0]?$'),
                value: ''
            }
        ]);
    }

    init() {
        const that = this;
        this.setPageParamsFromUrl();

        //te parametry ustawią się gdy wrócimy ze strony ze szczegółami towaru
        let searchParamsEncoded = that.getUrlParameter('searchparams');
        let params;

        if (searchParamsEncoded) {
            let searchParamsDecoded = decodeURIComponent(searchParamsEncoded);
            params = JSON.parse(searchParamsDecoded);

            if (params.price_min) {
                $('.js-cena-od').val(params.price_min);
            }
            if (params.price_max) {
                $('.js-cena-do').val(params.price_max);
            }
            if (params.order_by) {
                $('.js-towary-sort-select').val(params.order_by);
            }
            if (params.items_per_page) {
                $('.js-ilosc-na-strone-select').val(params.items_per_page);
            }
            if (params.nazwa_towaru) {
                $('.js-towar-nazwa').val(params.nazwa_towaru);
            }
        }
        this.setPageParamsFromSession();

        this.events();

        // Walidacja
        this.validation.init();
    }

    setPageParamsFromUrl() {
        const that = this;
        let page = that.getUrlParameter('p');
        that.towarSettings.id_kategorii = that.getUrlParameter('cat');
        //let items = that.getUrlParameter("items");

        if (page) {
            //that.towarSettings.ilosc_na_stronie = items;
            that.towarSettings.currentPage = parseInt(page);
        }
    }

    setPageParamsFromSession() {
        const that = this;
        $.ajax({
            url: 'towary/index.html?parametry_strony_json=true',
            method: 'post',
            //data: params,
            success: function (result) {
                if (result.data && result.data.numer_strony) {
                    that.towarSettings.currentPage = parseInt(
                        result.data.numer_strony
                    );
                }
                if (result.data && result.data.id_kategorii) {
                    that.towarSettings.id_kategorii = parseInt(
                        result.data.id_kategorii
                    );
                }
                that.pobierzTowary();
            },
            error: function (xhr, status, error) {
                that.pobierzTowary();
            }
        });
    }

    events() {
        const that = this;

        $('.js-towary-sort-select').off('change').on('change', function () {
            that.pobierzTowary();
        });

        $('.slider__desc-btn_buy')
            .off('click')
            .on('click', function (e) {
                e.preventDefault();
                that.dodajTowarDoKoszyka($(this).data('iksoris_towar_id'), 1);
            });

        $('.js-cena-od')
            .unbind('blur')
            .blur(function () {
                that.pobierzTowary();
            });

        $('.js-cena-do')
            .unbind('blur')
            .blur(function () {
                that.pobierzTowary();
            });

        $('.js-ilosc-na-strone-select')
            .unbind('change')
            .change(function () {
                that.pobierzTowary();
            });

        $('.js-wyczysc-btn').on('click', function () {
            that.resetSearchForm();
        });

        $('.js-szukaj-btn')
            .unbind('click')
            .click(function () {
                that.pobierzTowary();
            });

        $(document).on('click', '.page-switcher', function (e) {
            e.preventDefault();
            that.towarSettings.currentPage = $(this).data('page');
            that.pobierzTowary();
        });

        $('.js-towar-nazwa')
            .unbind('keypress')
            .keypress(function (e) {
                if (e.which === 13) {
                    that.pobierzTowary();
                }
            });

        $(document).on('click', '.js-dodaj-do-koszyka-btn', function (e) {
            let towar_id = $(this).data('towar_iksoris_id');
            let ilosc = parseInt(
                $(this)
                    .parent()
                    .find('.lista-towarow-ilosc')
                    .val()
            );

            that.dodajTowarDoKoszyka(towar_id, ilosc);
        });
    }

    getSearchParameters() {
        const that = this;
        const cena_od = $('.js-cena-od');
        const cena_do = $('.js-cena-do');
        let params = {};

        if (cena_od.is(':visible') && cena_od.val()) {
            params.price_min = cena_od.val();
        }

        if (cena_do.is(':visible') && cena_do.val()) {
            params.price_max = cena_do.val();
        }

        if ($('.js-towary-sort-select').is(':visible')) {
            params.order_by = $('.js-towary-sort-select option:selected').val();
        }

        if ($('.js-ilosc-na-strone-select').is(':visible')) {
            params.items_per_page = $(
                '.js-ilosc-na-strone-select option:selected'
            ).val();
        }

        if (
            $('.js-towar-nazwa').is(':visible') &&
            $('.js-towar-nazwa').val() != ''
        ) {
            params.nazwa_towaru = $('.js-towar-nazwa').val();
        } else {
            params.nazwa_towaru = that.getUrlParameter('szukaj');
        }

        // Wczytanie domyślnej kategorii dla strony głównej towarów lub kategorii wybranej
        if (this.productList.attr('data-default-category')) {
            //params.category_id = this.productList.attr("data-default-category");
        } else if (that.getUrlParameter('cat')) {
            params.category_id = that.getUrlParameter('cat');
        } else {
            params.category_id = this.towarSettings.id_kategorii;
        }

        params.page_no = 1;
        if ($('.page-switcher.current').length === 1) {
            params.page_no = $('.page-switcher.current').data('page');
        }

        return params;
    }

    pobierzTowary(params) {
        const that = this;

        params = params || that.getSearchParameters();

        $('#loading').addClass('loading_active');
        let pageTxt = '';

        if (that.towarSettings.currentPage) {
            pageTxt = '&p=' + that.towarSettings.currentPage;
        }

        $.ajax({
            url: '/towary/index.html?towary_json=true' + pageTxt,
            method: 'post',
            data: params,
            success: function (result) {
                $('#loading').removeClass('loading_active');

                that.towarSettings.towary = result.data;
                that.towarSettings.towary_total = result.total;

                if (result.total === 0) {
                    that.towarSettings.liczbaStron = 1;
                    that.productList.html(
                        '<div class="col-12"><div class="alert alert-warning text-center" role="alert">Brak towarów</div></div>'
                    );
                    $('.js-bottom-pager').html('');
                } else {
                    that.wypiszTowary();
                }
            },
            error: function (xhr, status, error) {
                $('#loading').removeClass('loading_active');
                console.error(status);
                console.error(error);
            }
        });
    }

    wypiszStronicowanie() {
        const that = this;
        //nie ma potrzeby robić stronicowania jeśli mamy tylko jedną stronę
        if (that.towarSettings.liczbaStron > 1) {
            //let kategoriaId = that.getUrlParameter('cat');
            let pager = '';
            if (that.towarSettings.currentPage > 1) {
                pager +=
                    '<a class="page-switcher page-switcher-left text-muted" href="#" data-page="' +
                    (that.towarSettings.currentPage - 1) +
                    '"><i class="fas fa-chevron-left"></i></a>';
            }

            for (let i = 1; i <= that.towarSettings.liczbaStron; i++) {
                pager +=
                    '<a class="page-switcher ' +
                    (i === that.towarSettings.currentPage ? 'current' : '') +
                    '" data-page="' +
                    i +
                    '" href="#">' +
                    i +
                    '</a>';
            }

            if (
                that.towarSettings.currentPage !==
                that.towarSettings.liczbaStron
            ) {
                pager +=
                    '<a class="page-switcher page-switcher-right text-muted" data-page="' +
                    (that.towarSettings.currentPage + 1) +
                    '" href="#"><i class="fas fa-chevron-right"></i></a>';
            }

            $('.js-bottom-pager').html(pager);
        } else {
            $('.js-bottom-pager').html('');
        }
    }

    wypiszTowary() {
        const that = this;
        let towaryHtml = '';
        let iloscNaStrone = $('.js-ilosc-na-strone-select').is(':visible')
            ? parseInt($('.js-ilosc-na-strone-select option:selected').val())
            : 10;

        that.towarSettings.liczbaStron = Math.ceil(
            that.towarSettings.towary_total / iloscNaStrone
        );
        if (that.towarSettings.liczbaStron === 0) {
            //jak brak wników to i tak wyświetlamy strona 1 z 1 ale pusta.
            that.towarSettings.liczbaStron = 1;
        }

        let counter = 0;
        let zdjecie_glowne = '';
        let strona_towaru = '';
        let opt_class;

        let seachOptions = that.getSearchParameters();
        seachOptions.page_no = that.towarSettings.currentPage;
        let encodedParams = encodeURIComponent(JSON.stringify(seachOptions));

        $.each(that.towarSettings.towary, function (index, row) {
            if (counter >= iloscNaStrone) {
                return;
            }

            zdjecie_glowne = row.zdjecie_glowne
                ? row.zdjecie_glowne
                : 'images/layout/noimage.png';
            strona_towaru = row.strona_towaru;

            if (strona_towaru === '#') {
                opt_class = 'js-brak-towaru-cms';
            } else {
                opt_class = 'js-jest-towar-cms';
                //strona_towaru += "&page=" + that.towarSettings.currentPage + "&items=" + that.towarSettings.ilosc_na_stronie;
                strona_towaru += '&searchparams=' + encodedParams;
            }

            const isTouchScreen = DetectMobileBrowsers.check()
                ? 'products-list__content_touch-screen'
                : '';

            // Etykieta towaru
            function ribbon(etykieta) {
                let ribbon = '';

                if (etykieta.length > 0) {
                    $.each(etykieta, function (index, element) {
                        ribbon += `
                                    <div class="products-list__content-ribbon">
                                        <div class="products-list__content-ribbon-background" style="background-color: ${element.kolorTla};"></div>
                                        <span class="products-list__content-ribbon-name" style="color: ${element.kolorCzcionki};">${element.nazwa}</span>
                                    </div>`;
                    });
                }

                return ribbon;
            }

            towaryHtml += `<div class="col-12 col-sm-6 col-lg-4 col-xl-3 products-list__item">
                        <div class="products-list__content ${opt_class} ${isTouchScreen}">
                            <a class="products-list__content-link" href="${strona_towaru}">
                                ${ribbon(row.etykieta)}
                                <div class="products-list__content-img" style="background-image: url(/${zdjecie_glowne})"></div>
                                <div class="text-center products-list__content-name">${row.nazwa}</div>
                                <div class="text-center products-list__content-price">`;
            if(row.cena_promocyjna){
                towaryHtml += `<div class="towar-cena-row">
                                   <span class="towar-stara-cena">${row.cena}<span> PLN</span></span>
                                   <span class="towar-nowa-cena">${row.cena_promocyjna}<span> PLN</span></span>
                                   <span class="towar-najnizsza-cena-30-dni">${row.towar_najnizsza_cena_info}</span>
                                   </div>`;
            } else {
                towaryHtml += row.cena + '<span> PLN</span>';
            }


            towaryHtml += `</div>
                            </a>
                            <div class="products-list__content-add">
                                <input class="lista-towarow-ilosc form-control" value="1" maxlength="2">
                                <button class="js-dodaj-do-koszyka-btn btn btn-outline-primary" data-towar_iksoris_id="${
                row.id
            }"><i class="fas fa-plus"></i> ${translates.do_koszyka}</button>
                            </div>
                        </div>
                    </div>`;

            counter++;
        });

        that.productList.html(towaryHtml);

        that.dopasujWysokosc();
        setTimeout(that.dopasujWysokosc, 500);

        $('.towar-wrapper.brak-towaru-cms').click(function (e) {
            e.preventDefault();
        });

        that.wypiszStronicowanie();
        that.handleShopItemHover();
    }

    handleShopItemHover() {
        $('.blok-towaru').hover(
            function () {
                if ($(this).find('.js-jest-towar-cms').length === 1) {
                    $(this)
                        .find('.form-dodaj-towar')
                        .css('visibility', 'visible');
                }
            },
            function () {
                $(this)
                    .find('.form-dodaj-towar')
                    .css('visibility', 'hidden');
            }
        );
    }

    dopasujWysokosc() {
        $(function () {
            $('.towar-image-wrapper').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
        });
        $(function () {
            $('.products-list__content-name').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
        });

        $(function () {
            $('.towar-wrapper').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
        });
    }

    dodajTowarDoKoszyka(id, nowaIlosc, callback) {
        $('#loading').addClass('loading_active');
        $.ajax({
            url: '/towary/index.html',
            method: 'get',
            data: {
                id: id,
                liczba: nowaIlosc,
                update: 'y'
            },
            success: function (result) {
                $('#loading').removeClass('loading_active');
                let modal = new MessageModal();
                if (result && result.status === 'success') {
                    modal.pokazDialog('', 'Towar został dodany do koszyka');
                    BasketShortSummary.init();
                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                } else {
                    modal.pokazDialog(
                        'Błąd',
                        result.message ||
                        'Wystąpił błąd w trakcie dodawania towaru'
                    );
                }
            },
            error: function (xhr, status, error) {
                $('#loading').removeClass('loading_active');
                console.error(status);
                console.error(error);
            }
        });
    }

    getUrlParameter(sParam) {
        let sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined
                    ? true
                    : sParameterName[1];
            }
        }
    }

    resetSearchForm() {
        const fields = [
            {
                field: $('.js-towary-sort-select'),
                defaultValue: 0
            },
            {
                field: $('.js-ilosc-na-strone-select'),
                defaultValue: 10
            },
            {
                field: $('.js-towar-nazwa'),
                defaultValue: ''
            },
            {
                field: $('.js-cena-od'),
                defaultValue: ''
            },
            {
                field: $('.js-cena-do'),
                defaultValue: ''
            }
        ];

        $.each(fields, function (index) {
            let element = fields[index];

            element.field.val(element.defaultValue);
        });

        this.pobierzTowary();
    }
}

export default Towary;
